import { Card } from "antd";
import React from "react";
import styles from "../alloBrain.module.css";

const Summary = ({ states }) => {
  return (
    <Card title={<h1>Summary</h1>} className={styles.summary}>
      <div className={styles.summary_body}>
        <div className={styles.summary_total_states}>
          <h3>Total states</h3>
          <b>{states.length}</b>
        </div>
        <div className={styles.summary_validated_states}>
          <h3>Validated states</h3>
          <b>
            {states.length - states.filter((state) => state.logs.length).length}
          </b>
        </div>
        <div className={styles.summary_failed_states}>
          <h3>Failed states</h3>
          <b>{states.filter((state) => state.logs.length).length}</b>
        </div>
      </div>
    </Card>
  );
};

export default Summary;
